import API from '../Common/Endpoint/serviceConstrants';
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';

export const callAddSpecialListGetApi = async () => {
  const { data = [] } = await axiosInstanceClient.get(API.activeSpecials);
  return data;
};